export const COMPLETE_TO = 2020;
export const MAX_YEAR = 2021;
export const MIN_YEAR = 2014;
export const GT_KEY = "UA-545956-9";
export const WORD_CLOUD_DEFAULT = 50;
